<script>
    import Logo from './common/Logo.svelte';
    import Space from './common/Space.svelte';
</script>

<Logo />
    <h1 class="thanks">Thanks for helping us improve our services!</h1>
<Space />